import { useStores } from "../../store/useStore";
import { Container } from "reactstrap";
import { observer } from "mobx-react";
import Jumbotron from "reactstrap/lib/Jumbotron";
import FullScreenMessage from "components/Billing/FullScreenMessage";

const AccountBlockedMessage = observer(() => {
  const { accountStore } = useStores();

  if (!accountStore.account?.blocked) {
    return null;
  }
  return (
    <FullScreenMessage>
      <Jumbotron className="h-100">
        <Container className="text-center">
          <h3 className="mt-3">Account Suspended</h3>
          <div className="mt-3 lead">
            Your account has been suspended. <br />
            If you believe this to be in error, please{" "}
            <a href="mailto:support@encharge.io">contact us</a>.
          </div>
        </Container>
      </Jumbotron>
    </FullScreenMessage>
  );
});

export default AccountBlockedMessage;
